<template>
	<div :style="viewStyles">
		<div class="row justify-content-center">
			<div class="col-12 mb-4" :style="'padding-bottom: '+pb+'px'">
				<div ref="fixedContent" class="row justify-content-center fixed-wrapper">
					<div class="col-11 pt-3">
						<barcode-scanner @change="addToList" @resize="updateStyle"/>
						<hr>
					</div>
				</div>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-11">

				<p>Flaschen <span class="text-medium-gray">({{ activeBottles.length }})</span></p>
			</div>
		</div>
		<template v-for="(bottle, serial) in bottles">
			<scanner-list-item :key="serial"
			                   v-if="bottle || showDeleted"
			                   :bottle-no="serial"
			                   :due-date="details[serial]?details[serial].due:undefined"
			>
				<template v-slot:default="{bottleNo}">
					<button
						class="btn btn-sm"
						@click="toggleBottle(bottleNo)"
					>
						<i v-if="bottle" class="fa fa-times"></i>
						<i v-else class="fa fa-trash-restore-alt"></i>
					</button>
				</template>

			</scanner-list-item>
		</template>

		<bottom-navigation @new-height="setBottomPadding">
			<template v-slot:left>
				<button class="btn btn-light btn-block" @click="$router.back()">
					{{ $t('Abbrechen') }}
				</button>
			</template>
			<template v-slot:right>
				<button :disabled="activeBottles.length === 0" class="btn btn-primary btn-block"
				        @click="continueWithCollection">
					{{ $t('Weiter') }}
				</button>
			</template>
		</bottom-navigation>
	</div>
</template>

<script>
import Vue from 'vue'
import ScannerListItem from "../../components/ScannerListItem";
import BottomNavigation from "../../components/BottomNavigation";
import BarcodeScanner from "../../components/BarcodeScanner";
import allViews from "../../mixins/allViews";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
	name: "Scanner",
	components: {BarcodeScanner, ScannerListItem, BottomNavigation},
	mixins: [allViews],
	data() {
		return {
			bottles: {},
			details: {},
			showDeleted: false,
			pb: 0,
		}
	},
	computed: {
		...mapState(['bottleCollection']),
		activeBottles() {
			return Object.keys(this.bottles).filter((el) => this.bottles[el]);
		},
	},
	mounted() {
		let bottles = {};
		let tempCollection = JSON.parse(JSON.stringify(this.bottleCollection));
		tempCollection.forEach(this.addToList);
	},
	updated() {
		this.setBottleCollection(this.activeBottles)
	},
	methods: {
		...mapActions({
			fetchBottleDetails: "Api/Bottles/get"
		}),
		...mapMutations(['setBottleCollection']),
		updateStyle() {
			this.pb = this.$refs.fixedContent.clientHeight
		},
		addToList(serial) {
			if (!this.bottles[serial]) {
				Vue.set(this.bottles, serial, true);
				this.fetchBottleDetails({id: serial})
					.then((bottle_detail) => {
						Vue.set(this.details, serial, bottle_detail)
					})
					.catch(console.log);
			}
		},
		toggleBottle(serial) {
			Vue.set(this.bottles, serial, !this.bottles[serial]);
		},
		continueWithCollection() {
			this.$router.push('/at_customer/scanner/customer').catch(() => null)
		}
	}
}
</script>
